import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
import { Salad, Sparkles, Dumbbell, Moon, Scale, Brain } from 'lucide-react';
export function MethodPillars() {
  const pillars = [{
    icon: <Salad className="w-6 h-6 text-gold" data-id="element-378" />,
    title: 'Nutrición Antiinflamatoria',
    subtitle: "No se trata de 'comer sano'. Se trata de nutrición estratégica que revierte la inflamación crónica.",
    learn: ['Los 12 alimentos que aceleran el envejecimiento', 'Timing correcto para optimizar colágeno', 'Reducción de hinchazón facial en 7 días'],
    science: 'Harvard Medical School confirma que reduce marcadores de envejecimiento en 40%.'
  }, {
    icon: <Sparkles className="w-6 h-6 text-gold" data-id="element-379" />,
    title: 'Piel Regenerativa',
    subtitle: 'Olvidate de las cremas milagrosas. Activos validados clínicamente que realmente funcionan.',
    learn: ['Los 3 activos que SÍ regeneran piel', 'Rutina AM/PM personalizada (5 min)', 'Productos argentinos que funcionan'],
    science: 'Cosmoprof demuestra que rutinas personalizadas aumentan firmeza en 35%.'
  }, {
    icon: <Dumbbell className="w-6 h-6 text-gold" data-id="element-380" />,
    title: 'Movimiento Inteligente',
    subtitle: 'No necesitás vivir en el gimnasio. Ejercicio específico que preserva masa muscular.',
    learn: ['Rutina de 10 minutos en casa', 'Ejercicios que preservan músculo post-40', 'Cómo evitar rigidez matutina'],
    science: 'Journal of Aging Research confirma que 10 min diarios mantienen masa muscular.'
  }, {
    icon: <Moon className="w-6 h-6 text-gold" data-id="element-381" />,
    title: 'Sueño Profundo',
    subtitle: 'El 73% de las mujeres +40 duerme mal. Sin sueño reparador, tu cuerpo no se regenera.',
    learn: ['Protocolo nocturno de 7 minutos', 'Cómo regular cortisol (despertares 3 AM)', 'Ritmo circadiano optimizado'],
    science: 'Sleep Foundation confirma que el sueño profundo produce el 80% de regeneración.'
  }, {
    icon: <Scale className="w-6 h-6 text-gold" data-id="element-382" />,
    title: 'Balance Hormonal',
    subtitle: 'Después de los 40, tus hormonas cambian. Si no las balanceás, todo lo demás falla.',
    learn: ['Cómo estabilizar insulina y cortisol', 'Alimentos que regulan estrógeno', 'Suplementación científica'],
    science: 'The Guardian muestra que el balance natural reduce inflamación sistémica en 45%.'
  }, {
    icon: <Brain className="w-6 h-6 text-gold" data-id="element-383" />,
    title: 'Regulación Nerviosa',
    subtitle: "Si vivís en modo 'alerta permanente', tu cuerpo envejece más rápido.",
    learn: ['Técnicas de regulación validadas', 'Respiración consciente (baja cortisol)', "Salir del modo 'supervivencia'"],
    science: 'Cosmetics Business reporta 50% menos arrugas de expresión con sistema regulado.'
  }];
  return <Section bg="cream-dark" data-id="element-384">
      <div className="text-center mb-20" data-id="element-385">
        <p className="text-xs font-medium tracking-[0.2em] text-gold uppercase mb-6" data-id="element-386">
          El Sistema Científico
        </p>
        <h2 className="text-4xl md:text-6xl font-serif text-charcoal mb-6" data-id="element-387">
          Método Wellaging 360°
        </h2>
        <p className="text-xl text-charcoal-light font-light max-w-2xl mx-auto" data-id="element-388">
          El primer sistema integral argentino respaldado por ciencia. 6 pilares
          diseñados para mujeres que están cansadas de promesas falsas.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-389">
        {pillars.map((pillar, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: idx * 0.1
      }} className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-gold/10 hover:shadow-soft hover:border-gold/30 transition-all group flex flex-col h-full" data-id="element-390">
            <div className="flex items-center justify-between mb-8" data-id="element-391">
              <div className="bg-cream-dark p-3 rounded-xl group-hover:bg-gold/10 transition-colors" data-id="element-392">
                {pillar.icon}
              </div>
              <span className="font-serif italic text-gold/50 text-2xl" data-id="element-393">
                0{idx + 1}
              </span>
            </div>

            <h3 className="text-2xl font-serif text-charcoal mb-4" data-id="element-394">
              {pillar.title}
            </h3>
            <p className="text-charcoal-light font-light text-sm leading-relaxed mb-8 flex-grow" data-id="element-395">
              {pillar.subtitle}
            </p>

            <div className="space-y-6" data-id="element-396">
              <ul className="space-y-3" data-id="element-397">
                {pillar.learn.map((item, i) => <li key={i} className="flex items-start gap-3 text-xs text-charcoal-light font-light" data-id="element-398">
                    <div className="w-1 h-1 rounded-full bg-olive mt-1.5 shrink-0" data-id="element-399" />
                    <span data-id="element-400">{item}</span>
                  </li>)}
              </ul>

              <div className="pt-4 border-t border-charcoal/5" data-id="element-401">
                <p className="text-[10px] uppercase tracking-widest text-olive font-medium mb-1" data-id="element-402">
                  Respaldo Científico
                </p>
                <p className="text-xs text-charcoal-light/70 font-light italic" data-id="element-403">
                  {pillar.science}
                </p>
              </div>
            </div>
          </motion.div>)}
      </div>

      <div className="mt-20 text-center max-w-2xl mx-auto" data-id="element-404">
        <div className="w-px h-12 bg-gold/30 mx-auto mb-8" data-id="element-405" />
        <p className="text-2xl font-serif italic text-charcoal mb-4" data-id="element-406">
          Estos 6 pilares trabajan juntos.
        </p>
        <p className="text-charcoal-light font-light" data-id="element-407">
          No son rutinas separadas. Es un sistema integrado donde cada elemento
          potencia al otro. Por eso funciona cuando todo lo demás falló.
        </p>
      </div>
    </Section>;
}